import AgentWorkflowDetailsPage from "aiagent/AgentWorkflowDetailsPage";
import AgentWorkflowUsagePage from "aiagent/AgentWorkflowUsagePage";
import AgentWorkflowsPage from "aiagent/AgentWorkflowsPage";
import AgentWorkflowRunDetailsPage from "aiagent/AgentWorkflowRunDetailsPage";
import AgentWorkflowRunsPage from "aiagent/AgentWorkflowRunsPage";
import {
  PAGE_NAVIGATION_TITLE,
  RUNS_TITLE,
  USAGE_TITLE,
  WORKFLOWS_TITLE
} from "aiagent/AgentWorkflowPageNavigation";
import entityLinkResolvers from "aiagent/markdown/entityLinkResolvers";
import { AGENT_WORKFLOW_FEATURE_FLAG } from "aiagent/Constants";
import withAgentWorkflowsLicense from "aiagent/components/withAgentWorkflowsLicense";
import useAgentWorkflowsLicensed from "aiagent/hooks/useAgentWorkflowsLicensed";
import useShowAgentWorkflowUsage from "aiagent/hooks/useShowAgentWorkflowUsage";
import AgentWorkflowRoutes from "./Routes";
const pluginExports = {
  routes: [
    {
      path: AgentWorkflowRoutes.unqualified.WORKFLOWS,
      component: withAgentWorkflowsLicense(AgentWorkflowsPage),
      permissions: ["agent_workflow:read"],
      requiredFeatureFlag: AGENT_WORKFLOW_FEATURE_FLAG
    },
    {
      path: AgentWorkflowRoutes.unqualified.workflowDetails(":id"),
      component: withAgentWorkflowsLicense(AgentWorkflowDetailsPage),
      permissions: ["agent_workflow:read"],
      requiredFeatureFlag: AGENT_WORKFLOW_FEATURE_FLAG
    },
    {
      path: AgentWorkflowRoutes.unqualified.RUNS,
      component: withAgentWorkflowsLicense(AgentWorkflowRunsPage),
      permissions: ["agent_workflow:debug"],
      requiredFeatureFlag: AGENT_WORKFLOW_FEATURE_FLAG
    },
    {
      path: AgentWorkflowRoutes.unqualified.runDetails(":id"),
      component: withAgentWorkflowsLicense(AgentWorkflowRunDetailsPage),
      permissions: ["agent_workflow:debug"],
      requiredFeatureFlag: AGENT_WORKFLOW_FEATURE_FLAG
    },
    {
      path: AgentWorkflowRoutes.unqualified.USAGE,
      component: withAgentWorkflowsLicense(AgentWorkflowUsagePage),
      permissions: ["agent_workflow:read"],
      requiredFeatureFlag: AGENT_WORKFLOW_FEATURE_FLAG
    }
  ],
  pageNavigation: [
    {
      description: PAGE_NAVIGATION_TITLE,
      children: [
        {
          description: WORKFLOWS_TITLE,
          path: AgentWorkflowRoutes.WORKFLOWS,
          permissions: ["agent_workflow:read"],
          requiredFeatureFlag: AGENT_WORKFLOW_FEATURE_FLAG,
          useCondition: useAgentWorkflowsLicensed
        },
        {
          description: RUNS_TITLE,
          path: AgentWorkflowRoutes.RUNS,
          permissions: ["agent_workflow:debug"],
          requiredFeatureFlag: AGENT_WORKFLOW_FEATURE_FLAG,
          useCondition: useAgentWorkflowsLicensed
        },
        {
          description: USAGE_TITLE,
          path: AgentWorkflowRoutes.USAGE,
          permissions: ["agent_workflow:read"],
          requiredFeatureFlag: AGENT_WORKFLOW_FEATURE_FLAG,
          useCondition: useShowAgentWorkflowUsage
        }
      ]
    }
  ],
  // Pluggable handlers for the `graylog://` URI scheme. Core's <Markdown> reads this
  // namespace, looks up the URI's first segment and either renders an in-app <Link> (for
  // resolvers returning {grnType, id}) or an anchor whose onClick({openSidebar}) opens an
  // entity in the right sidebar (for resolvers returning {onClick}). Our three resolvers
  // use the latter — core supplies `openSidebar` from its own `useRightSidebar` invocation.
  "markdown.entityLinkResolvers": [...entityLinkResolvers]
};
export default pluginExports;
